import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Codea from "../assets/statics/editacodea.png";
import { useContext, useEffect } from "react";
import Contexto from "../context/Contexto";

function Certificados() {
  const { cliente, buscarDataCliente } = useContext(Contexto);

  const location = useLocation();
  const [laUrl, setLaUrl] = useState("");
  const [cursones, setCursones] = useState([]);
  const [cursando, setCursando] = useState([]);
  useEffect(() => {
    setLaUrl(location.pathname.substr(14));
    buscarDataCliente(location.pathname.substr(14));
  }, []);
  let preparaRendidos = () => {
    let cursonesx = [];
    let claves = Object.keys(cliente.examenes);
    for (let i = 0; i < claves.length; i++) {
      let clave = claves[i];
      let nop = cliente.examenes[clave];
      nop.nombre = clave;
      if (nop.aprobado) {
        cursonesx.push(nop);
      }
    }
    console.log("cursonesx:", cursonesx);
    setCursones(cursonesx);
  };

  let prepararCursando = () => {
    let cursonesx = [];
    let claves = Object.keys(cliente.vencimientos);
    for (let i = 0; i < claves.length; i++) {
      let clave = claves[i];
      let nop = cliente.vencimientos[clave];
      nop.nombre = clave;
      //cursonesx.push(nop);
      let rana = true;

      for (let item in cursones) {
        if (cursones[item].nombre == clave) {
          rana = false;
        }
      }
      if (rana) {
        cursonesx.push(nop);
      }
      //
    }

    let checka = (clave) => {
      for (let item in cursones) {
        if (cursones[item].nombre == clave);
      }
    };
    console.log("cursonesx:", cursonesx);
    setCursando(cursonesx);
  };
  useEffect(() => {
    if (cliente) {
      console.log("cliente:", cliente);
      preparaRendidos();
      setTimeout(() => {
        prepararCursando();
      }, 1000);
    }
  }, [cliente]);
  return (
    <>
      <div className="contenedorPerfil">
        <div className="datasPerfil">
          <h1>{cliente && cliente.username}</h1>
          <h5>Curso y aprobo:</h5>
          {cursones.map((item, i) => {
            return <p>{item.nombre}</p>;
          })}
          <h5>Y se encuentra cursando:</h5>
          {cursando.map((item, i) => {
            return <p>{item.nombre}</p>;
          })}
        </div>
        <div className="colorcito off">
          <img src={Codea} alt="CodeaRock.com" className="off codealoco" />
        </div>
      </div>
    </>
  );
}

export default Certificados;
